<template>
  <div>
    <div class="videoList" id="videoList"  v-infinite-scroll="loadMore" infinite-scroll-disabled="finite" infinite-scroll-distance="40">
      <div class="et-tabhead">
              <span class="et-back" @click="detail">
                <i class="icon-back"></i>
                详情
              </span>
        <div class="et-tabtn">
          <div class="et-tabtn" id="but-tabtn"><!--@click="form(1)"--><!-- @click="form(2)"-->
              <span :class="category?'btn-et-form et-form-on':'btn-et-form'" @click="form(1)">
                    <i class="icon-Recommend"></i>推荐
                  </span>
              <span :class="category?'btn-et-form':'btn-et-form et-form-on'"  @click="form(0)">
                <i class="icon-whole"></i>全部
              </span>
          </div>
        </div>
      </div>
      <div class="list show-box">
        <!-- 双列显示 瀑布流？ -->
        <ul class="show-list" ref="listL">
          <li class="video-border"  v-for="(item,i) in relatedVideoL" v-if="item"  style="margin-top: 10px" @click="water(item)">
            <a href="javascript:void(0);">
              <div class="pic-box pic-margin">
                <!--item.file.thumb_url:item.recommend_image-->
                <img  :src="item.recommend_image+'?p=3&o=2&w=350&h=197'"/>
                <i class="icon-time">{{item.file.time_span | formatSeconds}}</i>
              </div>
              <p>{{item.file.title,14|ellipsis}}</p>
              <div class="vode-user" v-if="item.user.nick_name">
                <i class="icon-mine"><img :src="item.user.face_url" alt=""/></i>{{item.user.nick_name,9|ellipsis}}
              </div>
              <div class="vode-user" v-else>
                <i class="icon-mine"><img :src="item.user.face_url" alt=""/></i>{{item.nickname,9|ellipsis}}
              </div>
            </a>
            <div class="vote_bg"></div>
          </li>
        </ul>
        <ul class="show-list" ref="listR">
          <li class="video-border"  v-for="(item,i) in relatedVideoR" v-if="item"  style="margin-top: 10px" @click="water(item)">
            <a href="javascript:void(0);">
              <div class="pic-box pic-margin">
                <img  :src="item.recommend_image+'?p=3&o=2&w=350&h=197'"/>
                <i class="icon-time">{{item.file.time_span | formatSeconds}}</i>
              </div>
              <p>{{item.file.title,14|ellipsis}}</p>
              <div class="vode-user" v-if="item.user.nick_name">
                <i class="icon-mine"><img :src="item.user.face_url" alt=""/></i>{{item.user.nick_name,9|ellipsis}}
              </div>
              <div class="vode-user" v-else>
                <i class="icon-mine"><img :src="item.user.face_url" alt=""/></i>{{item.nickname,9|ellipsis}}
              </div>
            </a>
            <div class="vote_bg"></div>
          </li>
        </ul>
      </div>
      <!-- load -->
      <div class="content index-content" v-show="busy" style="padding-top: 0">
        <div class="id-content-inner">
          <div class="loader">
            <div class="loader-inner ball-pulse" style="display: block">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="noMore" class="footer" style="text-align: center;padding: 5px 0 10px 0;color: #ccc;display: none">没有更多了</div>

    </div>
  </div>

</template>

<script>
  export default {
    data ()
  {
    return {
      relatedVideo: [],
      relatedVideoL: [],
      relatedVideoR: [],
      FileRelatedVideo: null,
      id: '',
      page: 0,
      limit: 10,
      total: '',
      scrill: true,
      category: false,
      is_recommend: 0,
      // len: 10,
      fileItem: null,
      tops: '0',
      data: '',
      busy: false,
      noMore: false,
      leave: false,
      LH: 0,
      RH: 0,
      LW: 0,
    }
  },
  computed: {
    finite: function(){
      return this.busy || this.noMore ||this.leave;
    }
  },
  methods: {
    //操作按钮事件
    detail(){
      this.$router.push({name: 'Detail', params: {id: this.id}})
    },
    water(item){
     // this.data = new Date()
      if(item.file_type == 'video'){
        this.$router.push({name:'VideoName',params: {id:item.activity_mini.id,uuid: item.file.uuid,type:'video'}})
      }else{
        this.$router.push({name:'VideoName',params: {id:item.activity_mini.id,uuid:item.file.uuid,type:'image'}})
      }
    },
    form(type){
      var that = this;
      if(type == 0){
        // that.len = that.limit;
        that.category=false;
      }else{
        // that.len = that.limit;
        that.category=true
      }
      that.is_recommend = type;
      that.page = 0;
      that.relatedVideo = [];
      that.relatedVideoL = [];
      that.relatedVideoR = [];
      that.noMore = false;
      var FileRelatedVideo = {
        type: '1',
        activity_id: that.id,
        limit: that.limit,
        page: that.page,
        is_recommend:  that.is_recommend
      };
      that.loadMore(FileRelatedVideo)

    },
    fetchData (fileRelated) {
      var that = this;
      // that.len = that.len/1+10;
      if(fileRelated){
        that.FileRelatedVideo = fileRelated
      }else{
        that.FileRelatedVideo = {
          type: 1,
          activity_id: that.id,
          pagesize: that.limit,
          page: that.page,
          is_recommend:  that.is_recommend
        };
      }

      that.$http.get(API.FileRelatedVideo, {params: that.FileRelatedVideo})
        .then(function (res) {
          if(res.code == 0){
            var _data = res.data;
            that.total = res.total;

            that.loadImg(res);
          }
        })
    },
    loadImg(res){
      var that = this;
      var data = res.data;
      var total = res.total;
      var idx = 0;
      var NH,NW,CH,OH = 100;
      var img = new Image();
      function loadNext(idx){
        if(idx >= data.length) {
          that.busy = false;
          if(that.relatedVideo.length >= total){
            that.noMore = true;
          }
          return;
        }

        img.src = data[idx].file.thumb_url +'?p=3&o=2&w=350&h=197';
        img.onload = img.onerror = () => {
          // console.log(img.naturalHeight,img.naturalWidth,'img');
          NW = img.naturalWidth;
          NH = img.naturalHeight;
          CH = NH/NW*that.LW || OH;
          if(that.getMinUl()){
            that.relatedVideoL.push(data[idx]);
            that.LH += CH;
          }else{
            that.relatedVideoR.push(data[idx]);
            that.RH += CH;

          }
          that.relatedVideo.push(data[idx]);
          idx++;
          loadNext(idx);
        }
      }
      loadNext(idx);
    },
    loadMore (FileRelatedVideo) {
      if(this.busy == false){
        // setTimeout(() => {
          this.busy = true;
          this.page ++
          this.fetchData(FileRelatedVideo)
        // }, 500)
      }
    },
    getMinUl() { //每次获取最短的ul,将图片放到其后

      // var L = this.$refs.listL;
      // var R = this.$refs.listR;
      // var LH = L.offsetHeight;
      // var RH = R.offsetHeight;
       // console.log(this.LH, this.RH)
      // return LH <= RH ? true : false;
      return this.LH <= this.RH ? true : false;

    },
  }
  ,
  created: function () {
    this.id = this.$route.params.id;
    this.route = this.$route.params.route;
    var that = this;
    that.$http.get(API.GetActivitieById, {params: {id: that.id}})
      .then(function (res) {
        //console.log(res)
        let metas = $('head').children('meta');
        //document.title = res.data.title || '上电视/视频播放';
       // console.log(document.title)
        var  desc = '',
              img = res.data.playbill.playbill;
        if(res.data.description){
          desc = res.data.description
        }else{
          desc = metas[1].content;
        }
        //console.log(img)
        var dataName = {
            title: res.data.title,  //分享标题
            desc: desc,//metas[1].content,//分享简介(内容)
            imgAddress: img,//分享图片地址
            Retain: '',//保留
            url:  window.location.href //点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
          };
        //console.log(dataName)
          that.weixinShare(dataName)
      })

  },
  mounted: function () {
    //操作DOM
    var that = this;

   this.LW = this.$refs.listL.offsetWidth;
  },
  activated: function(){
    this.leave = false;
  },
  deactivated: function(){
    this.leave = true;
  }

  }
</script>

<style scoped>
 .videoList .show-box .show-list{
    width: 50%;
    float: left;
    padding-right:  5px;
  }
  .show-box .show-list li {
  float: left;
  width: 100%;

}
.show-box .show-list .pic-box img {
    visibility: visible;
    min-height: 50px;
}

</style>



// WEBPACK FOOTER //
// src/components/list/videoList.vue